import { useEffect, useState } from "react";
import { toast } from "sonner";
import { GoldDots } from "@/components/Brand";
import { Switch } from "@/components/ui/switch";
import { errMsg, useApi } from "@/lib/api";
import { useMe } from "@/context/MeContext";
import { Panel, Row } from "@/components/admin/AdminUI";
import { AdminTesters } from "@/components/admin/AdminTesters";

export const AdminAccess = () => {
  const api = useApi();
  const { refresh } = useMe();
  const [a, setA] = useState(null);
  const [mail, setMail] = useState(null);
  useEffect(() => { api.get("/admin/email-status").then((r) => setMail(r.data)).catch(() => setMail({ key: "unreachable" })); }, [api]);
  const load = () => api.get("/admin/access").then((r) => setA(r.data));
  useEffect(() => { load(); }, [api]); // eslint-disable-line
  const toggle = async (open) => {
    try { await api.put("/admin/plans-open", { open }); await refresh(); load(); toast.success(open ? "Action Plans are open to everyone" : "Action Plans are closed to the public"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!a) return <div className="py-16 flex justify-center"><GoldDots /></div>;
  return (
    <div className="space-y-5">
      <Panel title="Action Plan access" testId="access-plans">
        <div className="flex items-center justify-between gap-4" data-testid="plans-open-card">
          <div>
            <p className="font-medium text-charcoal">Action Plans open to everyone</p>
            <p className="text-sm text-ink-soft">{a.plans_open ? "Anyone signed in can start a plan." : "Closed: only admins and testers can start a plan. Others can sign up, but see a \"coming soon\" note."}</p>
          </div>
          <Switch checked={a.plans_open} onCheckedChange={toggle} data-testid="plans-open-switch" />
        </div>
      </Panel>
      <AdminTesters />
      <Panel title="Admins" sub="Admins can use every screen and look after accounts, but can't see anyone's Action Plans. Change roles in People and sessions." testId="access-admins">
        <ul className="space-y-2">{a.admins.map((x) => <li key={x.user_id} className="rounded-xl bg-alabaster px-4 py-3 text-[15px]">{x.name || "Admin"} · <span className="text-ink-soft">{x.email}</span></li>)}</ul>
        <p className="text-sm text-ink-soft mt-4">These emails become admin automatically on their first verified sign-in: {a.admin_emails.join(", ")}</p>
      </Panel>
      <Panel title="Sign-in and security" testId="access-security">
        <Row label="Sign-in methods">{a.sign_in_methods.join(" and ")}</Row>
        <Row label="Password reset">6-digit code by email</Row>
        <Row label="Age check">18 and over, confirmed at sign-up</Row>
        <Row label="Safety alerts sent to">{a.safety_alert_email}</Row>
        <Row label="Emails sent from">
          <span data-testid="email-sender-status">{!mail ? "Checking" : mail.key === "valid" && mail.domain_status === "verified"
            ? "noreply@ahucoach.com (Resend, verified)"
            : `Emergent's address, shown as AHU Coach (${mail.key === "missing" ? "no Resend key yet" : mail.key === "invalid" ? "the Resend key isn't valid" : mail.key === "valid" ? `ahucoach.com is ${mail.domain_status} in Resend` : "Resend couldn't be reached"})`}</span>
        </Row>
        <Row label="Cookies">Essential sign-in cookies only, no tracking</Row>
      </Panel>
    </div>
  );
};
